var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstampsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.364 15.11V4.89494C16.3646 4.25995 16.6173 3.65116 17.0665 3.20216C17.5157 2.75316 18.1247 2.50063 18.76 2.5H42.0053L55.9399 16.5484V54.0475C55.9387 54.6816 55.6861 55.2894 55.2375 55.7378C54.7889 56.1863 54.1808 56.4387 53.5463 56.44H37.9112",
    stroke: "#077CA5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.504 2.54794V14.513C41.5052 15.1472 41.7578 15.755 42.2064 16.2034C42.6551 16.6518 43.2631 16.9043 43.8976 16.9056H55.868M47.6079 25.8812H30.7304M47.6079 45.0239H40.9044M47.6079 35.4537H34.3208M2 49.212L3.7964 56.392H28.934L30.7304 49.212M2 49.212C2.00064 47.3082 2.75772 45.4825 4.10476 44.1365C5.4518 42.7905 7.27851 42.0344 9.18319 42.0344H12.7736V35.6431C11.4042 34.8528 10.3339 33.633 9.72878 32.1727C9.12366 30.7125 9.0175 29.0934 9.42676 27.5667C9.83602 26.04 10.7378 24.691 11.9923 23.7288C13.2468 22.7666 14.7839 22.245 16.3652 22.245C17.9465 22.245 19.4835 22.7666 20.738 23.7288C21.9925 24.691 22.8944 26.04 23.3036 27.5667C23.7129 29.0934 23.6067 30.7125 23.0016 32.1727C22.3965 33.633 21.3262 34.8528 19.9568 35.6431V42.032H23.5472C25.4519 42.032 27.2786 42.7905 28.6256 44.1365C29.9727 45.4825 30.7297 47.3082 30.7304 49.212M2 49.212H30.7304",
    stroke: "#077CA5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstampsIcon);
export default __webpack_public_path__ + "static/media/EstampsIcon.6b6610401ab5026eec0274f9774d9a07.svg";
export { ForwardRef as ReactComponent };